import { DataAction } from '../../@types';

export function createRepeatActions<TRequest, TActionType extends string>(
	originalAction: (request: TRequest) => DataAction<TActionType, TRequest>,
	defaultRequest: TRequest
): {
	action: (request: TRequest) => DataAction<TActionType, TRequest>;
	repeatAction: () => DataAction<TActionType, TRequest>;
} {
	let lastRequest: TRequest | null = null;

	const action = (request: TRequest) => {
		lastRequest = request;

		return originalAction(request);
	};

	const repeatAction = () => originalAction(lastRequest ?? defaultRequest);

	return {
		action,
		repeatAction
	};
}
